import styled from "@emotion/styled";

export function AssessmentsDeprecationBanner() {
  return (
    <Container>
      <span>
        Update: from June 2025, the practice tests feature will no longer be
        available in the Candidate Portal.
      </span>
      <a
        href="https://support.hire.toggl.com/en/articles/11477335-changes-to-the-candidate-portal"
        target="_blank"
        rel="noreferrer"
      >
        Learn more
      </a>
    </Container>
  );
}
const Container = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.orange[20]};
  display: flex;
  height: 36px;
  justify-content: center;

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
    margin-right: 12px;
  }

  a {
    background: ${({ theme }) => theme.colors.white};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors.purple[100]};
    display: block;
    line-height: 100%;
    padding: 4px 12px;
    text-decoration: none;
  }
`;
